import {Component, OnInit} from '@angular/core';
import {EventsService} from '../../../events.service';

@Component({
  selector: 'app-prizes-gulf',
  templateUrl: './prizes-gulf.component.html',
  styleUrls: ['./prizes-gulf.component.scss']
})
export class PrizesGulfComponent implements OnInit {
  winners: any;

  constructor(private eventService: EventsService,) {
  }

  ngOnInit(): void {
    this.eventService.getGulfWinners().subscribe((res) => {
      this.winners = res.participants;
      console.log(res)
      // this.loadIndicator = false;

    });

  }

}
